import { render, staticRenderFns } from "./SineWave.vue?vue&type=template&id=b73066d8&"
import script from "./SineWave.vue?vue&type=script&lang=js&"
export * from "./SineWave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports